import React, { useEffect, useState } from "react";
import {
  Deletecategories,
  FetchQuestionnaireList,
  Uploadcategoriescreate,
  UploadQuestionnaireList,
} from "../../../api/helper";
import { CATEGORIES_CREATE } from "../../../api/url";
import { ShowToast } from "../../../helpers/ToastService";

import { Fetchcategoriescreate, updatePreData } from "../../../api/helper";
import AddNewQuestionnaire from "./AddNewQuestionnaire";
import AddQuestion from "./AddQuestion";
import CategoryList from "./EnnVitalManagement/CategoryList";
import QuestionList from "./EnnVitalManagement/QuestionList";
import { useSelector } from "react-redux";
import AddCategoryAndQuestions from "./AddCategoryAndQuestions";
const AddCategory = () => {
  const profiledata = useSelector((state) => state?.cookies?.userDetails);
  const [form, setForm] = useState({
    id: "",
    label: "",
    description: "",
    name: "",
    abbreviation: "",
    agencyId: profiledata._id,
  });
  const [ranges, setRanges] = useState([
    {
      id: 1,
      rangeStart: "",
      rangeEnd: "",
      interpretation: "",
      color: "",
    },
  ]);
  const [loading, setLoading] = useState(false);
  const [questionnaires, setquestionnaires] = useState([]);
  const [categories, setcategories] = useState([]);
  const [activeTab, setActiveTab] = useState("CatrgoryList");
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
  const [ismodal, setIsModal] = useState(false);
  const openModal = () => {
    setIsModal(true);
  };
  const CloseModal = () => {
    setIsModal(false);
  };
  const GetFetchcategoriescreate = async () => {
    try {
      const response = await Fetchcategoriescreate(
        `agencyId=${profiledata._id}&preSet=true`
      );
      setcategories(response?.data?.categories);
    } catch (error) {
      console.log(error);
    }
  };

  const GetQuestionnairelist = async () => {
    try {
      const response = await FetchQuestionnaireList(
        `agencyId=${profiledata._id}&preSet=true`
      );
      setquestionnaires(response?.data?.questionnaires);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // if (answers.length === 0) {
    //   ShowToast("Please ensure all answers are filled in.");
    //   return;
    // }
    // if (form.name === "" || form.abbreviation === "") {
    //   ShowToast("Please fill in all fields.");
    //   return;
    // }
    const data = {
      ...form,
      ranges: JSON.stringify(ranges),
    };
    setLoading(true);
    try {
      const response = await UploadQuestionnaireList(data);
      if (response) {
        ShowToast("Category created successfully");
        GetFetchcategoriescreate();
        CloseModal();
      }
    } catch (error) {
      CloseModal();
      console.error("Error creating category:", error);
      ShowToast(
        error?.response?.data?.message ||
          "Something went wrong ! Please check console"
      );
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    GetQuestionnairelist();
    GetFetchcategoriescreate();
  }, []);

  const handelDeleteCategory = async (id) => {
    setLoading(true);
    try {
      const response = await Deletecategories(id);
      if (response) {
        ShowToast("Category deleted successfully");
        GetFetchcategoriescreate();
      }
    } catch (error) {
      console.error("Error deleting category:", error);
      ShowToast(
        error?.response?.data?.message ||
          "Something went wrong ! Please check console"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {ismodal && (
        <AddCategoryAndQuestions
          CloseModal={CloseModal}
          GetFetchcategoriescreate={GetFetchcategoriescreate}
        />
      )}
       <div
      >
      <div
        style={{
          alignItems: "center",
          display: "flex",
          justifyContent: "space-between",
          
        }}
      >
        <h1>
          {activeTab === "AddCategory" ? "Questions List" : "Saved Categories"}
        </h1>
        <div
          className="tabs-container__two"
          style={{ justifyContent: "flex-start" }}
        >
          <button
            className={`pill ${activeTab === "CatrgoryList" ? "active" : ""}`}
            onClick={() => handleTabClick("CatrgoryList")}
          >
            Categories
          </button>
          <button
            className={`pill ${activeTab === "AddCategory" ? "active" : ""}`}
            onClick={() => handleTabClick("AddCategory")}
          >
            Question
          </button>
        </div>

        {activeTab === "AddCategory" ? (
          <button
            className="add-button_user"
            style={{ float: "right" }}
            onClick={openModal}
          >
            Add New Question
          </button>
        ) : (
          <button
            className="add-button_user"
            style={{ float: "right" }}
            onClick={openModal}
          >
            Add New Category
          </button>
        )}

  
      </div>
          {activeTab === "AddCategory" ? (
        <QuestionList
          categories={categories}
          handelDeleteCategory={handelDeleteCategory}
        />
      ) : (
        <>
          <CategoryList
            categories={categories}
            setCategories={setcategories}
            GetFetchcategoriescreate={GetFetchcategoriescreate}
            handelDeleteCategory={handelDeleteCategory}
          />
        </>
      )}
</div>
    </>
  );
};

export default AddCategory;
